import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/exam-categories/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const examCategories = {
  getAll: apiPathFunc(pathBase),
} as const;
